"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromCustomType = exports.CustomTypeDef = void 0;
const tslib_1 = require("tslib");
const fp_ts_1 = require("fp-ts");
const function_1 = require("fp-ts/lib/function");
const t = tslib_1.__importStar(require("io-ts"));
const WidgetDef_1 = require("./fields/WidgetDef");
const utils_1 = require("./utils");
const codec = t.strict({
    id: t.string,
    definitions: t.array(WidgetDef_1.WidgetDef),
});
const CustomTypeDefType = "CustomTypeDef";
exports.CustomTypeDef = new t.Type("CustomTypeDef", (u) => (0, utils_1.hasType)(u) && u.type === CustomTypeDefType, (u) => {
    return (0, function_1.pipe)(codec.decode(u), fp_ts_1.either.map(({ id, definitions }) => {
        return {
            customTypeId: id,
            type: CustomTypeDefType,
            definitions: definitions.reduce((acc, { key, def }) => {
                return { ...acc, [key]: def };
            }, {}),
        };
    }));
}, (c) => c);
function fromCustomType(model, sharedSlices) {
    const flattenWidgets = Object.values(model.json)
        .map((tab) => Object.entries(tab))
        .reduce((acc, tabEntries) => [...acc, ...tabEntries], []);
    const definitions = flattenWidgets.reduce((acc, [key, widget]) => {
        return { ...acc, [key]: (0, WidgetDef_1.fromWidgetField)(widget, sharedSlices) };
    }, {});
    return {
        customTypeId: model.id,
        type: CustomTypeDefType,
        definitions,
    };
}
exports.fromCustomType = fromCustomType;
